const STORAGE_KEY = "seiva_theme"
const MODES = ["auto", "light", "dark"]

function currentMode() {
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return MODES.includes(stored) ? stored : "auto"
}

const ThemeSelector = {
  mounted() {
    this.sync = () => this.syncActive()
    this.handleClick = (event) => {
      const button = event.target.closest("[data-theme-option]")
      if (!button || !this.el.contains(button)) return

      const mode = button.dataset.themeOption
      if (!MODES.includes(mode)) return

      window.setSeivaTheme?.(mode)
      this.syncActive()
    }

    this.el.addEventListener("click", this.handleClick)
    window.addEventListener("storage", this.sync)
    this.syncActive()
  },

  destroyed() {
    this.el.removeEventListener("click", this.handleClick)
    window.removeEventListener("storage", this.sync)
  },

  syncActive() {
    const mode = currentMode()

    this.el.querySelectorAll("[data-theme-option]").forEach((button) => {
      const active = button.dataset.themeOption === mode
      button.setAttribute("aria-checked", active ? "true" : "false")
      button.classList.toggle("is-active", active)
    })

    this.el.querySelectorAll("[data-theme-current-label]").forEach((node) => {
      node.textContent = this.el.dataset[`label${mode[0].toUpperCase()}${mode.slice(1)}`] || mode
    })
  }
}

export default ThemeSelector
